import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Col, Container, Row } from '@paypalcorp/pp-react-grid';
import _asyncToGenerator from '@babel/runtime/helpers/esm/asyncToGenerator';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import _typeof from '@babel/runtime/helpers/esm/typeof';
import { CaptionText } from '@paypalcorp/pp-react-text';
import '../__generated__/styles/subNavBar.css';
import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/esm/getPrototypeOf';

// //https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/onreadystatechange
var getData = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url) {
    var config,
      method,
      req,
      response,
      _args = arguments;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          config = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
          method = config.method || 'GET';
          _context.prev = 2;
          req = new XMLHttpRequest();
          req.open(method, url, true);
          req.withCredentials = config.withCredentials || false;
          _context.next = 8;
          return new Promise(function (resolve, reject) {
            req.onreadystatechange = function () {
              if (req.readyState === 4) {
                if (req.status >= 200 && req.status < 300) {
                  var result = JSON.parse(req.response || req.responseText);
                  resolve(result);
                } else {
                  reject("HTTP Error: ".concat(req.status));
                }
              }
            };
            req.addEventListener('error', function (event) {
              reject(event);
            });
            req.send();
          });
        case 8:
          response = _context.sent;
          return _context.abrupt("return", {
            data: response
          });
        case 12:
          _context.prev = 12;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", Promise.reject(_context.t0));
        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 12]]);
  }));
  return function () {
    return _ref.apply(this, arguments);
  };
}();

/**
 *  method to validate is empty.
 * @param value
 * @returns {boolean}
 */
var isEmpty = function (value) {
  return value === null || _typeof(value) === 'object' && Object.keys(value).length === 0 || typeof value === 'string' && value.trim().length === 0;
};

/**
 * Deep clone to remove the reference of the object.
 * @param data
 * @returns {*}
 */
var deepClone = function (data) {
  try {
    return JSON.parse(JSON.stringify(data));
  } catch (e) {
    return data;
  }
};
var getCurrentHostName = function () {
  return window.location.hostname;
};
var whiteListedStageHosts = ['customer-support-r--helpcomponents', 'components.paypalinc.com', 'github.paypal.com'];

/* eslint-disable consumerweb/no-indexof */
var isHostWhitelistedForStageEnv = function () {
  var currentHostName = getCurrentHostName();
  var isWhitelisted = whiteListedStageHosts.find(function (hostName) {
    return currentHostName.indexOf(hostName) > -1;
  });
  return !!isWhitelisted;
};
var isDevEnv = function () {
  var hostName = getCurrentHostName();
  return hostName.includes('localhost');
};

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var defaultOptions = {
  pgrp: 'main:help:components',
  page: 'main:help:components',
  comp: 'helpComponents'
};
var analyticsObject = function () {
  try {
    return window && window.PAYPAL && window.PAYPAL.analytics;
  } catch (e) {
    return {};
  }
};

// Get FPTI otions
var getFPTIOptions = function (fptiOptions, eventType) {
  var fpti = window && window.fpti ? deepClone(window.fpti) : {};

  // clearing out error props in case they exist
  fpti.erpg = undefined;
  fpti.erfd = undefined;
  fpti.eccd = undefined;

  // Merge client passed fptiOptions with fpti object.
  fpti = _objectSpread$2(_objectSpread$2({}, fpti), fptiOptions);

  // TODO :: This logic needs to be revisited.
  // FPTI options passed through props

  if (isEmpty(fpti.page) || isEmpty(fpti.pgrp)) {
    fpti.page = defaultOptions.page;
    fpti.pgrp = defaultOptions.pgrp;
  }

  // Resetting to empty string for not to set link/pgln,phlk for ac events.
  fpti.link = '';
  fpti.pgln = '';
  fpti.pglk = '';

  // For click events
  if (fptiOptions.link) {
    fpti.link = fptiOptions.link;
    fpti.pgln = "".concat(fpti.page, "|").concat(fptiOptions.link);
    fpti.pglk = "".concat(fpti.pgrp, "|").concat(fptiOptions.link);
  }

  // Add event name to FPTI object
  fpti.event_name = '';
  if (fptiOptions.event_name) {
    fpti.event_name = fptiOptions.event_name;
  }

  // component name priority - fpti options props/analytics window object/default fallback
  if (isEmpty(fpti.comp)) {
    fpti.comp = defaultOptions.comp;
  }
  // Set event Type
  fpti.e = eventType ? eventType : 'ac'; // default activity event

  return fpti;
};

/**
 * @description
 *
 * Logs click metrics
 * @param {Object} fptiOptions
 * @property {String} options.data.page - Page name if not provided derived from the base page
 * @property {String} options.data.pgrp - Page group if not provided derived from the base page
 * e.g. var options = {data: {page:'page_name', pgrp: 'page_group_name'} }
 */
//https://github.paypal.com/pages/Tracking-R/client-side-instrumentation/react.html#/links?_k=flh93g
var recordClickEvent = function (fptiOptions) {
  if (analyticsObject()) {
    var options = getFPTIOptions(fptiOptions, 'cl');
    window.PAYPAL.analytics.Analytics.prototype.recordClick({
      data: options
    });
  }
};

// Error tracking
// https://github.paypal.com/pages/Tracking-R/client-side-instrumentation/#record_error
var recordErrorEvent = function (error) {
  if (window.PAYPAL && window.PAYPAL.trackJSError) {
    window.PAYPAL.trackJSError(error);
  }
};

// Record Activity Events
var recordEvent = function (fptiOptions) {
  if (analyticsObject()) {
    var options = getFPTIOptions(fptiOptions, 'ac');
    window.PAYPAL.analytics.Analytics.prototype.recordEvent(options.event_name, {
      data: options
    });
  }
};

// FPTI Prop Type
var FPTI_OBJECT = {
  page: PropTypes.string.isRequired,
  pgrp: PropTypes.string.isRequired,
  comp: PropTypes.string
};

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var SubNavItems = function (props) {
  var activeMenu = props.activeMenu,
    menuItems = props.menuItems,
    fptiOptions = props.fptiOptions,
    appName = props.appName;

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(function () {
    // Fire FPTI on Component mount
    var fpti = _objectSpread$1(_objectSpread$1({}, fptiOptions), {}, {
      event_name: "hc_sub_nav_bar_loaded_".concat(appName)
    });
    recordEvent(fpti);
  }, []);
  var getNavItemClassName = function (item) {
    if (item.key === activeMenu) {
      return 'hc_sub_nav_bar_list-item hc_sub_nav_bar_list-item--active';
    }
    return 'hc_sub_nav_bar_list-item';
  };
  var menuItemOnClickHandler = function (e, item) {
    e.stopPropagation();
    var fptiName = item.name && item.name.toLowerCase().split(' ').join('_') || item.key;
    var updatedFpti = _objectSpread$1(_objectSpread$1({}, fptiOptions), {
      link: "hc-sub-nav-links|".concat(item.key, "|").concat(appName),
      event_name: "hc_sub_nav_clicked_".concat(fptiName, "_link_in_").concat(appName)
    });
    recordClickEvent(updatedFpti);
  };
  return function renderSubNavMenu() {
    var parsedNavItems = menuItems.map(function (item) {
      return /*#__PURE__*/React.createElement("li", {
        className: getNavItemClassName(item),
        key: item.key,
        "data-testid": "hc-sub-nav-bar-item"
      }, /*#__PURE__*/React.createElement("a", {
        href: item.url,
        className: "hc_sub_nav_bar_list-item_anchor",
        "data-testid": "hc-sub-nav-bar-item-anchor",
        target: item.target || '_self',
        onClick: function onClick(e) {
          return menuItemOnClickHandler(e, item);
        }
      }, /*#__PURE__*/React.createElement(CaptionText, {
        "data-testid": "hc-sub-nav-bar-item-text"
      }, item.label)));
    });
    return /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Container, {
      className: "hc_sub_nav_bar_list_container",
      "data-testid": "hc-sub-nav-bar-list-container"
    }, /*#__PURE__*/React.createElement("ul", {
      className: "hc_sub_nav_bar_list",
      "data-testid": "hc-sub-nav-bar-items"
    }, parsedNavItems)));
  }();
};
SubNavItems.propTypes = {
  activeMenu: PropTypes.string.isRequired,
  menuItems: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  appName: PropTypes.string.isRequired,
  fptiOptions: PropTypes.shape(FPTI_OBJECT).isRequired
};

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inherits(ErrorBoundary, _React$Component);
  var _super = _createSuper(ErrorBoundary);
  function ErrorBoundary(props) {
    var _this;
    _classCallCheck(this, ErrorBoundary);
    _this = _super.call(this, props);
    _this.state = {
      error: null,
      errorInfo: null
    };
    return _this;
  }
  _createClass(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(err, errorInfo) {
      this.setState({
        err: err,
        errorInfo: errorInfo
      });
      if (typeof this.props.cbOnError === 'function') {
        // Callback function to track errors.
        this.props.cbOnError(err, errorInfo);
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.state.error) {
        // render any custom fallback UI
        return this.props.children;
      }
      if (this.props.suppressError) {
        return /*#__PURE__*/React.createElement("div", null);
      }
      return /*#__PURE__*/React.createElement("h1", null, 'Something went wrong in loading the widget.');
    }
  }]);
  return ErrorBoundary;
}(React.Component);
ErrorBoundary.propTypes = {
  suppressError: PropTypes.bool.isRequired,
  children: PropTypes.node,
  cbOnError: PropTypes.func.isRequired // callback function on error.
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var getSubNavUrl = function () {
  if (isDevEnv()) {
    return 'http://localhost.paypal.com:8081/smarthelp/api/hc-get-sub-nav-meta-data';
  }
  if (isHostWhitelistedForStageEnv()) {
    return 'https://www.te-alm-28885702111314774839541.qa.paypal.com/smarthelp/api/hc-get-sub-nav-meta-data';
  }
  return '/smarthelp/api/hc-get-sub-nav-meta-data';
};
var HcSubNavBar = function (props) {
  var activeMenu = props.activeMenu,
    appName = props.appName,
    fptiOptions = props.fptiOptions,
    suppressError = props.suppressError;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    navItems = _useState2[0],
    setNavItems = _useState2[1];
  var getMetaData = function () {
    getData(getSubNavUrl()).then(function (response) {
      var listItems = response && response.data && response.data.metaData || [];
      return setNavItems(listItems);
    }).catch(function () {
      var errorFPTIOptions = _objectSpread(_objectSpread({}, fptiOptions), {}, {
        page: "".concat(fptiOptions.page, "-error"),
        event_name: "hc_sub_nav_bar_service_error_".concat(appName)
      });
      recordEvent(errorFPTIOptions);
      return setNavItems([]);
    });
  };

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(function () {
    getMetaData();
  }, []);

  // Method to handle events on component error.
  // On component error fire impression event to track error cases.
  var handleErrorBoundaryCatch = function (error) {
    var finalFPTIOptions = _objectSpread(_objectSpread({}, fptiOptions), {}, {
      event_name: "hc_sub_nav_bar_error_boundary_".concat(appName)
    });
    recordErrorEvent(error);
    recordEvent(finalFPTIOptions);
  };
  // Render SubNav
  return function renderNavItems() {
    if (Array.isArray(navItems) && navItems.length > 0) {
      return /*#__PURE__*/React.createElement(ErrorBoundary, {
        suppressError: suppressError,
        cbOnError: handleErrorBoundaryCatch
      }, /*#__PURE__*/React.createElement(Container, {
        fluid: true,
        "data-testid": "hc-sub-nav-bar-container",
        className: "hc_sub_nav_bar_container"
      }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(SubNavItems, {
        activeMenu: activeMenu,
        menuItems: navItems,
        appName: appName,
        fptiOptions: fptiOptions
      }))));
    }
    return null;
  }();
};
HcSubNavBar.propTypes = {
  suppressError: PropTypes.bool,
  activeMenu: PropTypes.string.isRequired,
  appName: PropTypes.string.isRequired,
  fptiOptions: PropTypes.shape(FPTI_OBJECT).isRequired
};
HcSubNavBar.defaultProps = {
  suppressError: true,
  activeMenu: '',
  appName: ''
};

export { HcSubNavBar };
